export default "__VITE_ASSET__Df_vpBt9__"